import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { GamedayWrapper } from './Gameday.style';
import LiveDataContainer from '@gameday/components/Live/containers/LiveDataContainer';
import FinalContainer from '@gameday/components/Final/containers/FinalDataContainer';
import FieldVision from '@gameday/components/FieldVision/FieldVision';
import PreviewDataContainer from '@gameday/components/Preview/containers/PreviewDataContainer';
import PromoInterstitialOverlay from '@gameday/components/Interstitial/components/PromoInterstitialOverlay';

const Gameday = ({
    showFieldVision,
    game_view
}) => {
    let LiveCom = null;
    if (game_view === 'live') {
        LiveCom = (!showFieldVision) ? <LiveDataContainer /> : <FieldVision />;
    }

    return (
        <GamedayWrapper>
            <PromoInterstitialOverlay />
            {game_view === 'preview' && <PreviewDataContainer />}
            {LiveCom}
            {game_view === 'final' && <FinalContainer />}
        </GamedayWrapper>
    );
};

Gameday.propTypes = {
    showFieldVision: PropTypes.bool,
    game_view: PropTypes.string
};

export default memo(Gameday);
